import { SxProps } from '@mui/system';

export const sxs = <Theme extends object = Record<string, unknown>>(
    inputSxs: (SxProps<Theme> | undefined)[],
): SxProps<Theme> => inputSxs.flatMap((inputSx) => (Array.isArray(inputSx) ? inputSx : [inputSx]));
